import React from 'react';

interface InfoPageProps {
  t: (key: string) => string;
  onContinue: () => void;
}

const InfoPage: React.FC<InfoPageProps> = ({ t, onContinue }) => (
  <div className="info-page">
    <div className="info-box">
      <p className="info-title">{t('infoTitle') || 'Willkommen zur Sitzplatz-Auswahl'}</p>
      <p>{t('infoIntro') || 'Diese App ermöglicht es Ihnen, Ihre Sitzplätze für die Veranstaltung auszuwählen und zu bestätigen. Bitte gehen Sie wie folgt vor:'}</p>
      <ol className="info-list">
        <li>{t('infoStep1')}</li>
        <li>{t('infoStep2')}</li>
        <li>{t('infoStep3')}</li>
        <li>{t('infoStep4')}</li>
        <li style={{ whiteSpace: 'pre-line' }}>{t('infoStep5')}</li>
      </ol>
      <button
        className="login-button info-continue-btn"
        onClick={onContinue}
      >
        {t('continue') || 'Weiter'}
      </button>
    </div>
  </div>
);

export default InfoPage;
